import RadioShowCanvas from "../Canvas/RadioShowCanvas"
import "./Ad.css"

export default function Ad() {
    return (
        <div className="ad-main-container">
            <div className="ad-main">
                <div className="ad-container">
                    <div className="ad-content">
                        {/* <RadioShowCanvas
                            width={308}
                            height={183}
                            effect="equalizer"
                            textAnimation="zoom"
                        /> */}
                    </div>
                    <div className="ad-content">
                        {/* <RadioShowCanvas
                            width={308}
                            height={183}
                            title="Trance Music"
                            time="16:00 GMT"
                            subtitle="Listen every day"
                            backgroundGradient={["#502630ff", "#6d4526ff", "#1a5c26ff"]}
                            glowColor="#00e5ff"
                            accentColor="#ff4ecf"
                            effect="waves"
                            textAnimation="slide"
                            speed={2}
                        /> */}
                    </div>
                </div>
            </div>
        </div>
    );
};